import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=5cc7f676&scoped=true"
import script from "./CreateAccount.vue?vue&type=script&lang=ts"
export * from "./CreateAccount.vue?vue&type=script&lang=ts"
import style0 from "./CreateAccount.vue?vue&type=style&index=0&id=5cc7f676&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc7f676",
  null
  
)

export default component.exports